export default {
  subTitle: 'Settings',
  pageTitle: 'Agreement documents'
}